import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChartNoAxesCombined, CreditCard, UserRoundCheck } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { grpImg } from "@/assets";

const AuthDisplay = () => {
  const changeStats = [
    {
      id: 2,
      title: "Transactions",
      amount: "1,238",
      percentage: "18%",
      desc: "Daily transaction",
      icon: <CreditCard className="text-blue-500" />,
      color: "#eff6ff",
    },
    {
      id: 1,
      title: "Active Users",
      amount: "3,582",
      percentage: "12%",
      desc: "Last week analytics",
      icon: <UserRoundCheck className="text-green-500" />,
      color: "#f0fdf4",
    },
    {
      id: 3,
      title: "New Visitors",
      amount: "778",
      percentage: "15%",
      desc: "Updated this week",
      icon: <ChartNoAxesCombined className="text-purple-500" />,
      color: "#faf5ff",
    },
  ];

  const [currentStatIndex, setCurrentStatIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStatIndex((prev) => (prev + 1) % changeStats.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentStat = changeStats[currentStatIndex];

  return (
    <div className="relative hidden h-full bg-slate-800 lg:block lg:w-[60%] xl:w-[65%]">
      <nav className="mt-5 flex w-full items-center justify-center px-5">
        <div className="flex w-fit items-center gap-10 rounded-full bg-black/20 px-5 py-3">
          {[
            { title: "Home", path: "/" },
            { title: "Contact", path: "/" },
          ].map((item, index) => (
            <Link
              href={item.path}
              key={index}
              className="flex items-center justify-center"
            >
              <p className="text-sm font-medium text-white">{item.title}</p>
            </Link>
          ))}
        </div>
      </nav>
      <div className="relative flex h-full items-center justify-center">
        <div className="absolute bottom-16 w-[80%]">
          <img src={grpImg} alt="hero-image" className="w-full" />
        </div>
      </div>
      {/* Stats */}
      <div className="font-archivo absolute top-20 right-10 flex w-[280px] items-start rounded-xl bg-white p-5 text-black">
        <div className="flex flex-1 flex-col gap-2">
          <AnimatePresence mode="popLayout">
            <motion.h3
              key={`title-${currentStatIndex}`}
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 20, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className="text-xl text-black/70"
            >
              {currentStat.title}
            </motion.h3>

            <motion.h2
              key={`amount-${currentStatIndex}`}
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 20, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut", delay: 0.1 }}
              className="text-3xl font-medium text-black/80"
            >
              {currentStat.amount}{" "}
              <span className={`text-xl font-medium text-green-500`}>
                (+{currentStat.percentage})
              </span>
            </motion.h2>

            <motion.p
              key={`desc-${currentStatIndex}`}
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 20, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
              className="text-lg text-black/50"
            >
              {currentStat.desc}
            </motion.p>
          </AnimatePresence>
        </div>

        <motion.div
          key={`icon-${currentStatIndex}`}
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 20, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut", delay: 0.3 }}
          className={`rounded-md bg-${currentStat.color}-50 p-4`}
          style={{ backgroundColor: currentStat.color }}
        >
          {currentStat.icon}
        </motion.div>
      </div>{" "}
    </div>
  );
};

export default AuthDisplay;
